module.exports = __webpack_public_path__ + "img/mit-virtual-reality-zur-bootsmesse.be034043.jpg";